import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import {
    useZitoneoContent,
    useZitoneoHotelRooms,
    useZitoneoServices,
} from '../../../../contexts/ZitoneoContentContext';
import { useZitoneoUI } from '../../../../contexts/ZitoneoUIContext';
import { VisibleContentScope } from '../../../../types/zitoneoServicesTypes';
import ImagesTabHeader from './ImagesTabHeader';
import ImageItem from './ImageItem';
import LoadingPlaceholder from '../../../../../../muiComponents/LoadingPlaceholder';
import '../../../../stylesheets/zitoneo-images.scss';

const ImagesTab = () => {
    const translate = useTranslate();
    const { hotelContent } = useZitoneoContent();
    const {
        selectedRoomId,
        selectedImageTypeKey,
        visibleContentScope,
        isLoading,
    } = useZitoneoUI();
    const { rooms } = useZitoneoHotelRooms();
    const { ComplementaryHotelImageTypes, handleUpdateHotelImage } =
        useZitoneoServices();
    const selectedRoom = rooms.find(room => room.Id === selectedRoomId);
    const isRoomScope = visibleContentScope === VisibleContentScope.ROOM;
    const allImages = isRoomScope
        ? selectedRoom?.HotelImages || []
        : hotelContent.HotelImages || [];
    const visibleImages = allImages.filter(image => !image.Deleted);
    const images =
        selectedImageTypeKey && !isRoomScope
            ? visibleImages.filter(
                  image => image.CategoryKey === selectedImageTypeKey
              )
            : visibleImages;
    const selectedImageType = ComplementaryHotelImageTypes.find(
        imageType => imageType.Key === selectedImageTypeKey
    );

    const roomImageType = ComplementaryHotelImageTypes.find(
        imageType => imageType.Key === 'BEDROOM'
    );
    const headerCategory =
        (isRoomScope ? roomImageType : selectedImageType) || null;

    const headerTitle = isRoomScope
        ? selectedRoom?.Label || ''
        : selectedImageType?.Name || translate('all');

    return (
        <section className='zitoneo-images-tab' aria-busy={isLoading}>
            <ImagesTabHeader category={headerCategory} title={headerTitle} />
            {isLoading ? (
                <LoadingPlaceholder
                    variant='rounded'
                    width='100%'
                    height={240}
                />
            ) : images.length ? (
                <ul className='zitoneo-images-tab__list'>
                    {images.map(image => {
                        return (
                            <ImageItem
                                key={image.Id}
                                image={image}
                                showCategory={
                                    !isRoomScope && !selectedImageTypeKey
                                }
                                onUpdate={(imageId, changes) =>
                                    handleUpdateHotelImage(
                                        imageId,
                                        changes,
                                        visibleContentScope ===
                                            VisibleContentScope.ROOM
                                            ? selectedRoomId
                                            : null
                                    )
                                }
                            />
                        );
                    })}
                </ul>
            ) : (
                <p className='zitoneo-images-tab__empty'>
                    {translate('no_images_available')}
                </p>
            )}
        </section>
    );
};

export default ImagesTab;
